/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const StatsPage = lazy(() => import('./pages/list/StatsPage'))

export const statisticheRoutes: RouteObject[] = [
  {
    path: 'statistiche',
    element: <StatsPage />,
  },
]